import { EuiButton, EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import React, { memo } from 'react';
import ComboBoxField from '../../../../components/Form/ComboBoxField';

export const RequiredItemsList = memo(
    ({
        requiredItems,
        errors,
        control,
        setValue,
        isLoadingItems,
        requiredItemVariantsMap,
        deleteSpecificExclusiveDiscountRequiredItems,
        handleVariantSelection,
        getSelectedExclusiveVariantOptions,
    }) => {
        if (!requiredItems?.length) return null;
        return (
            requiredItems?.length > 0 &&
            requiredItems.map((item, index) => {
                const itemId = item.item_id;
                const allVariants = requiredItemVariantsMap[itemId] || [];
                console.log(`adafasfdsaf Item [${index}]:`, {
                    item,
                    allVariants,
                    requiredItemVariantsMap,
                });
                const options = allVariants.length > 0 ? [...allVariants, { label: 'All', id: 'ALL' }] : [];
                const uniqueKey = `${item.item_id || item.id}_${index}`;
                return (
                    <EuiFlexItem key={uniqueKey}>
                        <EuiFlexGroup alignItems='flexEnd' style={{ width: '64rem' }}>
                            <EuiFlexItem grow={false} style={{ width: '270px' }}>
                                <ComboBoxField
                                    options={options}
                                    selectedOptions={
                                        getSelectedExclusiveVariantOptions(
                                            item,
                                            index,
                                            allVariants,
                                            `required_items[${index}].variant_options`
                                        ) || []
                                    }
                                    onChange={(selectedOptions) =>
                                        handleVariantSelection(
                                            selectedOptions,
                                            setValue,
                                            `required_items[${index}].variant_options`
                                        )
                                    }
                                    rules={{
                                        validate: (value, formValues) => {
                                            if (allVariants.length > 0) {
                                                const selectedVariants = getSelectedExclusiveVariantOptions(
                                                    item,
                                                    index,
                                                    allVariants,
                                                    `required_items[${index}].variant_options`
                                                );
                                                if (!selectedVariants || selectedVariants.length === 0) {
                                                    return `Please select at least one variant for ${
                                                        item?.label || 'item'
                                                    }`;
                                                }
                                            }
                                            return true;
                                        },
                                    }}
                                    errors={errors}
                                    label={`Select variants for ${item?.label || 'Item'}`}
                                    name={`required_items[${index}].variant_options`}
                                    placeholder={
                                        allVariants.length === 0
                                            ? 'Variants do not exist'
                                            : 'Please select at least one or more variants'
                                    }
                                    control={control}
                                    isDisabled={allVariants.length === 0}
                                    isLoading={isLoadingItems}
                                />
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <EuiButton
                                    iconType='minusInCircle'
                                    style={{ textAlign: 'left' }}
                                    onClick={() => {
                                        deleteSpecificExclusiveDiscountRequiredItems(itemId, null, index);
                                    }}
                                >
                                    Remove
                                </EuiButton>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFlexItem>
                );
            })
        );
    },
    (prevProps, nextProps) => {
        return (
            prevProps.requiredItems === nextProps.requiredItems &&
            prevProps.errors === nextProps.errors &&
            prevProps.control === nextProps.control &&
            prevProps.setValue === nextProps.setValue &&
            prevProps.isLoadingItems === nextProps.isLoadingItems &&
            prevProps.requiredItemVariantsMap === nextProps.requiredItemVariantsMap
        );
    }
);

export const ExclusiveRequiredItemsList = memo(
    ({
        items,
        exclusiveRequiredItems,
        errors,
        control,
        setValue,
        watch,
        isLoadingItems,
        exclusiveItemVariantsMap,
        deleteSpecificExclusiveRequiredItems,
        handleVariantSelection,
        getSelectedExclusiveVariantOptions,
    }) => {
        return (
            exclusiveRequiredItems?.length > 0 &&
            exclusiveRequiredItems.map((item, index) => {
                const allVariants = exclusiveItemVariantsMap[item.item_id] || [];
                const options = allVariants.length > 0 ? [...allVariants, { label: 'All', id: 'ALL' }] : [];
                const uniqueKey = `${item.item_id || item.id}_${index}`;
                return (
                    <EuiFlexItem key={uniqueKey}>
                        <EuiFlexGroup alignItems='flexEnd' style={{ width: '64rem' }}>
                            <EuiFlexItem grow={false} style={{ width: '270px' }}>
                                <ComboBoxField
                                    options={options}
                                    selectedOptions={
                                        getSelectedExclusiveVariantOptions(
                                            item,
                                            index,
                                            allVariants,
                                            `exclusive_required_items[${index}].variant_options`
                                        ) || []
                                    }
                                    onChange={(selectedOptions) =>
                                        handleVariantSelection(
                                            selectedOptions,
                                            setValue,
                                            `exclusive_required_items[${index}].variant_options`
                                        )
                                    }
                                    rules={{
                                        validate: (value, formValues) => {
                                            if (allVariants.length > 0) {
                                                const selectedVariants = getSelectedExclusiveVariantOptions(
                                                    item,
                                                    index,
                                                    allVariants,
                                                    `exclusive_required_items[${index}].variant_options`
                                                );
                                                if (!selectedVariants || selectedVariants.length === 0) {
                                                    return `Please select at least one variant for ${
                                                        item?.label || 'item'
                                                    }`;
                                                }
                                            }
                                            return true;
                                        },
                                    }}
                                    errors={errors}
                                    label={`Select variants for ${item?.label || 'Item'}`}
                                    name={`exclusive_required_items[${index}].variant_options`}
                                    placeholder={
                                        allVariants.length === 0
                                            ? 'Variants do not exist'
                                            : 'Please select at least one or more variants'
                                    }
                                    control={control}
                                    isDisabled={!allVariants?.length}
                                    isLoading={isLoadingItems}
                                />
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <EuiButton
                                    iconType='minusInCircle'
                                    style={{ textAlign: 'left' }}
                                    onClick={() => deleteSpecificExclusiveRequiredItems(item.item_id, null, index)}
                                >
                                    Remove
                                </EuiButton>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFlexItem>
                );
            })
        );
    },
    (prevProps, nextProps) => {
        return (
            prevProps.exclusiveRequiredItems === nextProps.exclusiveRequiredItems &&
            prevProps.errors === nextProps.errors &&
            prevProps.control === nextProps.control &&
            prevProps.setValue === nextProps.setValue &&
            prevProps.watch === nextProps.watch &&
            prevProps.isLoadingItems === nextProps.isLoadingItems &&
            prevProps.exclusiveItemVariantsMap === nextProps.exclusiveItemVariantsMap
        );
    }
);

RequiredItemsList.displayName = 'RequiredItemsList';
ExclusiveRequiredItemsList.displayName = 'ExclusiveRequiredItemsList';
